import dayjs from "dayjs";

export const DAILY_APPLY_LIMIT = 1;
export const WEEKLY_APPLY_LIMIT = 2;

/** Monday-start calendar week */
function startOfIsoWeek(d) {
  const day = d.day(); // 0 = Sun … 6 = Sat
  const diff = day === 0 ? -6 : 1 - day;
  return d.add(diff, "day").startOf("day");
}

function entryDate(item) {
  const raw =
    item?.created_at ||
    item?.applied_at ||
    item?.from ||
    item?.date ||
    item?.pivot?.created_at;
  const d = dayjs(raw);
  return d.isValid() ? d : null;
}

/**
 * Merge history + upcoming (dedupe by id) for limit checks.
 * @param {unknown[]} history
 * @param {unknown[]} [upcoming]
 */
export function mergeOfficeHourBookings(history = [], upcoming = []) {
  const map = new Map();
  [...(Array.isArray(history) ? history : []), ...(Array.isArray(upcoming) ? upcoming : [])].forEach(
    (item) => {
      if (!item || typeof item !== "object") return;
      const key = item.id != null ? `id-${item.id}` : JSON.stringify(item);
      if (!map.has(key)) map.set(key, item);
    }
  );
  return [...map.values()];
}

/**
 * @returns {{ canApply: boolean, reason: string|null, dailyCount: number, weeklyCount: number }}
 */
export function getOfficeHoursApplyEligibility(bookings = [], now = dayjs()) {
  const todayKey = now.format("YYYY-MM-DD");
  const weekStart = startOfIsoWeek(now);
  const weekEnd = weekStart.add(7, "day");

  let dailyCount = 0;
  let weeklyCount = 0;

  for (const item of Array.isArray(bookings) ? bookings : []) {
    const d = entryDate(item);
    if (!d) continue;
    if (d.format("YYYY-MM-DD") === todayKey) dailyCount += 1;
    if ((d.isAfter(weekStart) || d.isSame(weekStart, "day")) && d.isBefore(weekEnd)) {
      weeklyCount += 1;
    }
  }

  if (dailyCount >= DAILY_APPLY_LIMIT) {
    return {
      canApply: false,
      reason: "You can apply for only one office hour per day.",
      dailyCount,
      weeklyCount,
    };
  }
  if (weeklyCount >= WEEKLY_APPLY_LIMIT) {
    return {
      canApply: false,
      reason: "You can apply for at most two office hours per week.",
      dailyCount,
      weeklyCount,
    };
  }
  return { canApply: true, reason: null, dailyCount, weeklyCount };
}
